export function StepContainer({ title, src, alt, form, footer, className = '' }) {
    return (
        <div className={`d-flex flex-column overflow-hidden ${className}`}>
            <div className="overflow-hidden d-flex flex-column h-100">
                <div className="overflow-auto h-100">
                    {title &&
                        <div className="text-center">
                            <h5 className="font-weight-bold">{title}</h5>
                            {src &&
                                <img
                                    className="m-4"
                                    src={src}
                                    alt={alt}
                                    height="100px"
                                />
                            }
                        </div>
                    }
                    {form}
                </div>
                {footer &&
                    <div className="mt-3">
                        {footer}
                    </div>
                }
            </div>
        </div>
    )
}